import React, { useEffect, useState } from 'react';
import RichTextEditor, { EditorValue, ToolbarConfig } from 'react-rte';
import { Modal } from 'antd';
import { EditorState, Modifier } from 'draft-js';
import './custom.css'

const defaultToolbarConfig = {
  // Conferir: https://github.com/sstur/react-rte/blob/master/src/lib/EditorToolbarConfig.js
  display: [
    'INLINE_STYLE_BUTTONS',
    // 'BLOCK_ALIGNMENT_BUTTONS',
    'BLOCK_TYPE_BUTTONS',
    // 'BLOCK_TYPE_DROPDOWN',
    // 'HISTORY_BUTTONS',
  ],
  INLINE_STYLE_BUTTONS: [
    { label: 'Bold', style: 'BOLD', className: 'icon-custom icon-bold-custom' },
    { label: 'Italic', style: 'ITALIC', className: 'icon-custom icon-italic-custom' },
    { label: 'Underline', style: 'UNDERLINE', className: 'icon-custom icon-underline-custom' },
],
  BLOCK_TYPE_DROPDOWN: [
    { label: 'Normal', style: 'unstyled' },
    { label: 'Heading Large', style: 'header-one' },
    { label: 'Heading Medium', style: 'header-two' },
    { label: 'Heading Small', style: 'header-three' },
  ],
  BLOCK_TYPE_BUTTONS: [
    { label: 'UL', style: 'unordered-list-item', className: 'icon-custom icon-unordered-list-custom' },
    { label: 'OL', style: 'ordered-list-item', className: 'icon-custom icon-ordered-list-custom' },
],
  BLOCK_ALIGNMENT_BUTTONS: [
    { label: 'Align Left', style: 'ALIGN_LEFT' },
    { label: 'Align Center', style: 'ALIGN_CENTER' },
    { label: 'Align Right', style: 'ALIGN_RIGHT' },
    { label: 'Align Justify', style: 'ALIGN_JUSTIFY' },
  ],
} as ToolbarConfig;

interface Props {
  key?: string | number;
  title: string;
  initialValue?: string; // string html
  visible: boolean;
  readonlyText?: boolean;
  toolbarConfig?: ToolbarConfig;
  onOkRichText: (htmlString: string, textString: string) => void;
  onCancel: () => void;
}

export const ModalRichText: React.FC<Props> = ({
  key,
  title,
  initialValue,
  visible,
  readonlyText,
  toolbarConfig,
  onOkRichText,
  onCancel,
}) => {
  const [rteDescricao, setRteDescricao] = useState<EditorValue>(RichTextEditor.createEmptyValue());

  if (!toolbarConfig) {
    toolbarConfig = defaultToolbarConfig;
  }

  useEffect(() => {
    if (!visible) {
      setRteDescricao(RichTextEditor.createEmptyValue());
    }
    if (initialValue) {
      setRteDescricao(RichTextEditor.createValueFromString(initialValue, 'html'));
    }
  }, [visible]);

  const transformTextInVariable = (editorState: EditorState, typeVariable: string) => {
    let selection = editorState.getSelection();
    const anchorKey = selection.getAnchorKey();
    const currentContent = editorState.getCurrentContent();
    const currentBlock = currentContent.getBlockForKey(anchorKey);

    //Then based on the docs for SelectionState -
    const start = selection.getStartOffset();
    const end = selection.getEndOffset();
    const selectedText = currentBlock.getText().slice(start, end);

    var contentStateModified = Modifier.replaceText(
      rteDescricao.getEditorState().getCurrentContent(),
      selection,
      `{[${typeVariable}${selectedText.trim()}]}`,
      editorState.getCurrentInlineStyle(),
    );

    const editor = EditorState.createWithContent(contentStateModified);
    setRteDescricao(EditorValue.createFromState(editor));
  };

  const customControls = [
    (setValue: any, getValue: any, editorState: EditorState) => (
      <span key="btn-@" className={'richtext-btn'} onClick={() => transformTextInVariable(editorState, '@')}>
        @
      </span>
    ),
    (setValue: any, getValue: any, editorState: EditorState) => (
      <span key="btn-!" className={'richtext-btn'} onClick={() => transformTextInVariable(editorState, '!')}>
        !
      </span>
    ),
  ];

  const transformTextAreaRteToString = () => {
    var currentValue = rteDescricao.getEditorState().getCurrentContent();
    var blocks = currentValue.getBlocksAsArray();

    var resultString = '';
    for (let block of blocks) {
      resultString += block.getText() + ' ';
    }
    return resultString;
  };

  return (
    <Modal
      key={key}
      title={title}
      visible={visible}
      onOk={() => {
        const textoHtml = rteDescricao.toString('html');
        const textoString = transformTextAreaRteToString();

        onOkRichText(textoHtml, textoString);
      }}
      onCancel={onCancel}>
      <RichTextEditor
        readOnly={readonlyText}
        toolbarConfig={toolbarConfig}
        {...{ customControls }}
        value={rteDescricao}
        // rootStyle={{ border: 0 }}
        onChange={(value: EditorValue) => {
          // pegar o valor: value.toString('html');
          setRteDescricao(value);
        }}
      />
    </Modal>
  );
};

export default ModalRichText;
